import { useEffect, useState } from 'react';
import {
  Group,
  Title,
  Stack,
  Notification,
  Modal,
  Text,
  Avatar,
  Card,
  Divider,
  SimpleGrid,
  Box,
  Table,
  ThemeIcon,
  Badge,
  TextInput,
  Textarea,
  Select,
  Checkbox,
  Button,
  MultiSelect,
  Paper,
  ScrollArea,
  PasswordInput, // YENİ EKLENDİ
} from '@mantine/core';

import {
  IconSettings,
  IconX,
  IconCheck,
  IconLayoutDashboard,
  IconDevices,
  IconTerminal2,
  IconMailForward,
  IconApi,
  IconUsers,
  IconBuilding,
  IconPhone,
  IconQuote,
  IconMessageDots,
  IconChevronRight,
} from '@tabler/icons-react';

import { useNavigate } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import api from '../api/axiosConfig';

import RolesSettingsSection from '../components/settings/RolesSettingsSection';
import AppsSettingsSection from '../components/settings/AppsSettingsSection';
import UsersSettingsSection from '../components/settings/UsersSettingsSection';
import ConstructionSitesSection from '../components/settings/ConstructionSitesSection';
import ContactsSettingsSection from '../components/settings/ContactsSettingsSection';
import QuotesSettingsSection from '../components/settings/QuotesSettingsSection';
import FeedbackSettingsSection from '../components/settings/FeedbackSettingsSection';

import { availableIcons, mantineColors } from '../api/settingsConstants';
import ReleaseNotesAdminPage from '../components/settings/ReleaseNotesAdminPage';

export default function SettingsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('apps');
  const [currentUserRole, setCurrentUserRole] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [users, setUsers] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [apps, setApps] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const [constructionSites, setConstructionSites] = useState([]);
  const [selectedSiteId, setSelectedSiteId] = useState(null);

  const [opened, { open, close }] = useDisclosure(false);
  const [contactModalOpened, { open: openContactModal, close: closeContactModal }] = useDisclosure(false);
  const [quoteModalOpened, { open: openQuoteModal, close: closeQuoteModal }] = useDisclosure(false);
  const [appModalOpened, { open: openAppModal, close: closeAppModal }] = useDisclosure(false);
  const [roleModalOpened, { open: openRoleModal, close: closeRoleModal }] = useDisclosure(false);
  const [editUserModalOpened, { open: openEditUserModal, close: closeEditUserModal }] = useDisclosure(false);
  const [siteModalOpened, { open: openSiteModal, close: closeSiteModal }] = useDisclosure(false);
  const [viewDetailModalOpened, { open: openViewDetailModal, close: closeViewDetailModal }] = useDisclosure(false);

  const [selectedDetailItem, setSelectedDetailItem] = useState(null);
  const [detailType, setDetailType] = useState(null);

  const [contactForm, setContactForm] = useState({ id: null, name: '', title: '', ext: '', mobile: '' });
  const [quoteForm, setQuoteForm] = useState({ id: null, content: '' });
  const [roleForm, setRoleForm] = useState({ id: null, name: '', description: '' });

  const [appForm, setAppForm] = useState({
    id: null,
    title: '',
    description: '',
    icon: 'IconLayoutDashboard',
    path: '',
    color: 'blue',
    coming_soon: false,
    stat_key: '',
    stat_label: '',
    allowed_roles: ['*'],
    order: 0,
    is_active: true,
  });

  const [editUserForm, setEditUserForm] = useState({
    id: null,
    username: '',
    employee_name: '',
    employee_email: '',
    employee_phone: '',
    employee_type: '',
    employee_position: '',
    role: '',
    is_active: true,
    new_password: '', // YENİ EKLENDİ
  });

  const [workerForm, setWorkerForm] = useState({
    id: null,
    first_name: '',
    last_name: '',
    employee_type: 'SITE',
    position: '',
    phone: '',
    email: '',
    department: '',
    site_id: null,
    is_active: true,
  });

  const [siteForm, setSiteForm] = useState({
    id: null,
    name: '',
    location: '',
    description: '',
    project_manager: '',
    contact_phone: '',
    contact_email: '',
    start_date: '',
    expected_end_date: '',
    status: 'aktif',
    is_active: true,
  });

  const [isSubmittingContact, setIsSubmittingContact] = useState(false);
  const [isSubmittingQuote, setIsSubmittingQuote] = useState(false);
  const [isSubmittingRole, setIsSubmittingRole] = useState(false);
  const [isSubmittingApp, setIsSubmittingApp] = useState(false);
  const [isSubmittingEditUser, setIsSubmittingEditUser] = useState(false);
  const [isSubmittingSite, setIsSubmittingSite] = useState(false);
  const [isSubmittingReset, setIsSubmittingReset] = useState(false);

  useEffect(() => {
    const storedRole = localStorage.getItem('user_role');
    const safeRole = storedRole ? storedRole.toLowerCase() : '';
    setCurrentUserRole(safeRole);

    const initializePage = async () => {
      if (safeRole === 'admin') {
        await fetchUsers();
        await fetchContacts();
        await fetchQuotes();
        await fetchApps();
        await fetchRoles();
        await fetchConstructionSites();
        await fetchSites();
        await fetchFeedback();
      }
    };

    initializePage();
  }, []);

  const handleViewDetail = (item, type) => {
    setSelectedDetailItem(item);
    setDetailType(type);
    openViewDetailModal();
  };

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get('/admin/users/list');

      const normalizedUsers = res.data.map((user) => ({
        ...user,
        full_name: user.employee
          ? `${user.employee.first_name || ''} ${user.employee.last_name || ''}`.trim()
          : user.username,
        email: user.employee?.email || '',
        phone: user.employee?.phone || '',
      }));

      setUsers(normalizedUsers);
    } catch (err) {
      if (err.response?.status === 403) {
        setError('Kullanıcı listesini görüntüleme yetkiniz yok.');
      } else {
        setError('Kullanıcı listesi alınırken hata oluştu.');
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchFeedback = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/feedback');
      setFeedbacks(res.data);
    } catch (err) {
      console.error('Feedback çekilemedi', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchContacts = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/ip-phone');
      setContacts(res.data);
    } catch (err) {
      console.error('Rehber çekilemedi', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchQuotes = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/quotes');
      setQuotes(res.data);
    } catch (err) {
      console.error('Sözler çekilemedi', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchApps = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/dashboard/apps');
      setApps(res.data);
    } catch (err) {
      console.error('Modüller çekilemedi', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/roles');
      setRolesList(res.data);

      const formattedRoles = res.data.map((role) => ({
        value: role.name,
        label: `${role.name} ${role.description ? `(${role.description})` : ''}`,
      }));

      setAvailableRoles(formattedRoles);
    } catch (err) {
      console.error('Roller çekilemedi', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchConstructionSites = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/construction-sites');
      setConstructionSites(res.data);
    } catch (err) {
      console.error('Şantiye listesi çekilemedi', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchSites = async () => {
    try {
      const res = await api.get('/admin/employees/simple-sites');
      const formatted = res.data.map((site) => ({
        value: site.id.toString(),
        label: site.name,
      }));
      setSitesList(formatted);
    } catch (err) {
      console.error('Şantiyeler çekilemedi', err);
    }
  };

  const openEditUser = (user) => {
    setEditUserForm({
      id: user.id,
      username: user.username || '',
      employee_name: user.employee
        ? `${user.employee.first_name || ''} ${user.employee.last_name || ''}`.trim()
        : '',
      employee_email: user.employee?.email || '',
      employee_phone: user.employee?.phone || '',
      employee_type: user.employee?.employee_type || '',
      employee_position: user.employee?.position || '',
      role: user.role || '',
      is_active: user.is_active !== undefined ? user.is_active : true,
      new_password: '', // Modal açıldığında şifre alanı boş gelsin
    });
    openEditUserModal();
  };

  const openEditRole = (role) => {
    setRoleForm({ ...role });
    openRoleModal();
  };

  const openNewRole = () => {
    setRoleForm({ id: null, name: '', description: '' });
    openRoleModal();
  };

  const openEditContact = (contact) => {
    setContactForm({ ...contact });
    openContactModal();
  };

  const openNewContact = () => {
    setContactForm({ id: null, name: '', title: '', ext: '', mobile: '' });
    openContactModal();
  };

  const openEditQuote = (quote) => {
    setQuoteForm({ ...quote });
    openQuoteModal();
  };

  const openNewQuote = () => {
    setQuoteForm({ id: null, content: '' });
    openQuoteModal();
  };

  const openEditApp = (app) => {
    setAppForm({
      ...app,
      allowed_roles: app.allowed_roles || ['*'],
    });
    openAppModal();
  };

  const openNewApp = () => {
    setAppForm({
      id: null,
      title: '',
      description: '',
      icon: 'IconLayoutDashboard',
      path: '',
      color: 'blue',
      coming_soon: false,
      stat_key: '',
      stat_label: '',
      allowed_roles: ['*'],
      order: 0,
      is_active: true,
    });
    openAppModal();
  };

  const openNewSite = () => {
    setSiteForm({
      id: null,
      name: '',
      location: '',
      description: '',
      project_manager: '',
      contact_phone: '',
      contact_email: '',
      start_date: '',
      expected_end_date: '',
      status: 'aktif',
      is_active: true,
    });
    openSiteModal();
  };

  const openEditSite = (site) => {
    setSiteForm({ ...site });
    openSiteModal();
  };

  const handleSaveEditUser = async () => {
    setIsSubmittingEditUser(true);
    try {
      // YENİ EKLENDİ: Sadece şifre girilmişse payload'a dahil ediyoruz.
      const payload = {
        role: editUserForm.role,
        is_active: editUserForm.is_active,
      };

      if (editUserForm.new_password) {
        payload.password = editUserForm.new_password;
      }

      await api.put(`/admin/users/${editUserForm.id}`, payload);

      notifications.show({
        title: 'Başarılı',
        message: 'Kullanıcı güncellendi.',
        color: 'teal',
        icon: <IconCheck size={16} />,
      });

      fetchUsers();
      closeEditUserModal();
    } catch {
      notifications.show({
        title: 'Hata',
        message: 'Kullanıcı güncellenemedi.',
        color: 'red',
        icon: <IconX size={16} />,
      });
    } finally {
      setIsSubmittingEditUser(false);
    }
  };

  const handleSendPasswordReset = async () => {
    if (!editUserForm.employee_email) {
      notifications.show({
        title: 'E-posta Bulunamadı',
        message: 'Bu kullanıcının sistemde kayıtlı bir e-posta adresi yok.',
        color: 'yellow',
        icon: <IconX size={16} />,
      });
      return;
    }

    setIsSubmittingReset(true);
    try {
      await api.post(`/admin/users/${editUserForm.id}/reset-password`);
      notifications.show({
        title: 'Başarılı',
        message: 'Şifre sıfırlama bağlantısı kullanıcının e-posta adresine gönderildi.',
        color: 'teal',
        icon: <IconCheck size={16} />,
      });
    } catch (err) {
      notifications.show({
        title: 'Hata',
        message: 'Mail gönderilirken bir hata oluştu.',
        color: 'red',
        icon: <IconX size={16} />,
      });
    } finally {
      setIsSubmittingReset(false);
    }
  };

  const handleDeleteUser = (id) => {
    modals.openConfirmModal({
      title: 'Kullanıcıyı Sil',
      centered: true,
      children: <Text size="sm">Bu kullanıcıyı silmek istediğinize emin misiniz?</Text>,
      labels: { confirm: 'Sil', cancel: 'İptal' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await api.delete(`/admin/users/${id}`);
          fetchUsers();
          notifications.show({
            title: 'Başarılı',
            message: 'Kullanıcı silindi.',
            color: 'teal',
            icon: <IconCheck size={16} />,
          });
        } catch {
          notifications.show({
            title: 'Hata',
            message: 'Kullanıcı silinemedi.',
            color: 'red',
            icon: <IconX size={16} />,
          });
        }
      },
    });
  };

  const handleSaveRole = async () => {
    if (!roleForm.name) {
      notifications.show({ title: 'Uyarı', message: 'Rol Adı zorunludur.', color: 'yellow' });
      return;
    }

    setIsSubmittingRole(true);
    try {
      if (roleForm.id) {
        await api.put(`/admin/roles/${roleForm.id}`, roleForm);
      } else {
        await api.post('/admin/roles', roleForm);
      }

      fetchRoles();
      closeRoleModal();

      notifications.show({
        title: 'Başarılı',
        message: 'Rol kaydedildi.',
        color: 'teal',
        icon: <IconCheck size={16} />,
      });
    } catch {
      notifications.show({
        title: 'Hata',
        message: 'Rol kaydedilemedi.',
        color: 'red',
        icon: <IconX size={16} />,
      });
    } finally {
      setIsSubmittingRole(false);
    }
  };

  const handleDeleteRole = (id) => {
    modals.openConfirmModal({
      title: 'Rolü Sil',
      centered: true,
      children: <Text size="sm">Bu rolü silmek istediğinize emin misiniz?</Text>,
      labels: { confirm: 'Sil', cancel: 'İptal' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await api.delete(`/admin/roles/${id}`);
          fetchRoles();
          notifications.show({
            title: 'Başarılı',
            message: 'Rol silindi.',
            color: 'teal',
            icon: <IconCheck size={16} />,
          });
        } catch {
          notifications.show({
            title: 'Hata',
            message: 'Rol silinemedi.',
            color: 'red',
            icon: <IconX size={16} />,
          });
        }
      },
    });
  };

  const handleSaveContact = async () => {
    if (!contactForm.name || !contactForm.ext) {
      notifications.show({
        title: 'Uyarı',
        message: 'İsim ve Dahili alanları zorunludur.',
        color: 'yellow',
      });
      return;
    }

    setIsSubmittingContact(true);
    try {
      if (contactForm.id) {
        await api.put(`/admin/ip-phone/${contactForm.id}`, contactForm);
      } else {
        await api.post('/admin/create-ip-phone', contactForm);
      }

      fetchContacts();
      closeContactModal();

      notifications.show({
        title: 'Başarılı',
        message: 'Kişi kaydedildi.',
        color: 'teal',
        icon: <IconCheck size={16} />,
      });
    } catch {
      notifications.show({
        title: 'Hata',
        message: 'Kayıt işlemi başarısız oldu.',
        color: 'red',
        icon: <IconX size={16} />,
      });
    } finally {
      setIsSubmittingContact(false);
    }
  };

  const handleDeleteContact = (id) => {
    modals.openConfirmModal({
      title: 'Kişiyi Sil',
      centered: true,
      children: <Text size="sm">Bu kişiyi rehberden silmek istediğinize emin misiniz?</Text>,
      labels: { confirm: 'Sil', cancel: 'İptal' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await api.delete(`/admin/ip-phone/${id}`);
          fetchContacts();
          notifications.show({
            title: 'Başarılı',
            message: 'Kişi silindi.',
            color: 'teal',
            icon: <IconCheck size={16} />,
          });
        } catch {
          notifications.show({
            title: 'Hata',
            message: 'Kişi silinemedi.',
            color: 'red',
            icon: <IconX size={16} />,
          });
        }
      },
    });
  };

  const handleSaveQuote = async () => {
    if (!quoteForm.content.trim()) {
      notifications.show({
        title: 'Uyarı',
        message: 'Söz içeriği zorunludur.',
        color: 'yellow',
      });
      return;
    }

    setIsSubmittingQuote(true);
    try {
      if (quoteForm.id) {
        await api.put(`/admin/quotes/${quoteForm.id}`, quoteForm);
      } else {
        await api.post('/admin/quotes', quoteForm);
      }

      fetchQuotes();
      closeQuoteModal();

      notifications.show({
        title: 'Başarılı',
        message: 'Söz kaydedildi.',
        color: 'teal',
        icon: <IconCheck size={16} />,
      });
    } catch {
      notifications.show({
        title: 'Hata',
        message: 'Kayıt işlemi başarısız oldu.',
        color: 'red',
        icon: <IconX size={16} />,
      });
    } finally {
      setIsSubmittingQuote(false);
    }
  };

  const handleDeleteQuote = (id) => {
    modals.openConfirmModal({
      title: 'Sözü Sil',
      centered: true,
      children: <Text size="sm">Bu motivasyon sözünü silmek istediğinize emin misiniz?</Text>,
      labels: { confirm: 'Sil', cancel: 'İptal' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await api.delete(`/admin/quotes/${id}`);
          fetchQuotes();
          notifications.show({
            title: 'Başarılı',
            message: 'Söz silindi.',
            color: 'teal',
            icon: <IconCheck size={16} />,
          });
        } catch {
          notifications.show({
            title: 'Hata',
            message: 'Söz silinemedi.',
            color: 'red',
            icon: <IconX size={16} />,
          });
        }
      },
    });
  };

  const handleSaveApp = async () => {
    if (!appForm.title || !appForm.path || !appForm.icon) {
      notifications.show({
        title: 'Uyarı',
        message: 'Başlık, Yol ve İkon zorunludur.',
        color: 'yellow',
      });
      return;
    }

    const payload = {
      ...appForm,
      allowed_roles: appForm.allowed_roles?.length ? appForm.allowed_roles : ['*'],
      order: parseInt(appForm.order, 10) || 0,
    };

    setIsSubmittingApp(true);
    try {
      if (appForm.id) {
        await api.put(`/admin/dashboard/apps/${appForm.id}`, payload);
      } else {
        await api.post('/admin/dashboard/apps', payload);
      }

      fetchApps();
      closeAppModal();

      notifications.show({
        title: 'Başarılı',
        message: 'Modül kaydedildi.',
        color: 'teal',
        icon: <IconCheck size={16} />,
      });
    } catch {
      notifications.show({
        title: 'Hata',
        message: 'Kayıt başarısız.',
        color: 'red',
        icon: <IconX size={16} />,
      });
    } finally {
      setIsSubmittingApp(false);
    }
  };

  const handleDeleteApp = (id) => {
    modals.openConfirmModal({
      title: 'Modülü Sil / Gizle',
      centered: true,
      children: <Text size="sm">Bu modülü dashboard üzerinden kaldırmak istediğinize emin misiniz?</Text>,
      labels: { confirm: 'Kaldır', cancel: 'İptal' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await api.delete(`/admin/dashboard/apps/${id}`);
          fetchApps();
          notifications.show({
            title: 'Başarılı',
            message: 'Modül kaldırıldı.',
            color: 'teal',
            icon: <IconCheck size={16} />,
          });
        } catch {
          notifications.show({
            title: 'Hata',
            message: 'İşlem başarısız.',
            color: 'red',
            icon: <IconX size={16} />,
          });
        }
      },
    });
  };

  const handleSaveSite = async () => {
    if (!siteForm.name || !siteForm.location) {
      notifications.show({
        title: 'Uyarı',
        message: 'Şantiye Adı ve Lokasyon zorunludur.',
        color: 'yellow',
      });
      return;
    }

    setIsSubmittingSite(true);
    try {
      const payload = { ...siteForm };
      if (!payload.start_date) payload.start_date = null;
      if (!payload.expected_end_date) payload.expected_end_date = null;

      if (siteForm.id) {
        await api.put(`/admin/construction-sites/${siteForm.id}`, payload);
      } else {
        await api.post('/admin/construction-sites', payload);
      }

      fetchConstructionSites();
      fetchSites();
      closeSiteModal();

      notifications.show({
        title: 'Başarılı',
        message: 'Şantiye kaydedildi.',
        color: 'teal',
        icon: <IconCheck size={16} />,
      });
    } catch {
      notifications.show({
        title: 'Hata',
        message: 'Şantiye kaydedilemedi.',
        color: 'red',
        icon: <IconX size={16} />,
      });
    } finally {
      setIsSubmittingSite(false);
    }
  };

  const handleDeleteSite = (id) => {
    modals.openConfirmModal({
      title: 'Şantiyeyi Sil',
      children: <Text size="sm">Bu şantiyeyi silmek istediğinize emin misiniz?</Text>,
      labels: { confirm: 'Sil', cancel: 'İptal' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await api.delete(`/admin/construction-sites/${id}`);
          fetchConstructionSites();
          fetchSites();
          notifications.show({
            title: 'Başarılı',
            message: 'Şantiye silindi.',
            color: 'teal',
          });
        } catch {
          notifications.show({
            title: 'Hata',
            message: 'Silinemedi.',
            color: 'red',
          });
        }
      },
    });
  };

  const SelectedIcon = availableIcons.find((i) => i.value === appForm.icon)?.icon || IconLayoutDashboard;

  const sidebarItems = [
    { value: 'apps', label: 'Modüller', icon: IconLayoutDashboard, color: 'blue' },
    { value: 'users', label: 'Kullanıcılar', icon: IconUsers, color: 'cyan' },
    { value: 'roles', label: 'Roller', icon: IconSettings, color: 'violet' },
    { value: 'construction-sites', label: 'Şantiyeler', icon: IconBuilding, color: 'orange' },
    { value: 'contacts', label: 'Rehber', icon: IconPhone, color: 'green' },
    { value: 'quotes', label: 'Sözler', icon: IconQuote, color: 'grape' },
    { value: 'feedback', label: 'Geri Bildirim', icon: IconMessageDots, color: 'teal' },
    { value: 'release-notes', label: 'Sürüm Notları', icon: IconMessageDots, color: 'teal' },
  ];

  const renderActiveSection = () => {
    switch (activeTab) {
      case 'roles':
        return (
          <RolesSettingsSection
            loading={loading}
            activeTab={activeTab}
            rolesList={rolesList}
            fetchRoles={fetchRoles}
            openNewRole={openNewRole}
            openEditRole={openEditRole}
            handleDeleteRole={handleDeleteRole}
          />
        );
      case 'apps':
        return (
          <AppsSettingsSection
            loading={loading}
            activeTab={activeTab}
            apps={apps}
            fetchApps={fetchApps}
            openNewApp={openNewApp}
            openEditApp={openEditApp}
            handleDeleteApp={handleDeleteApp}
          />
        );
      case 'users':
        return (
          <UsersSettingsSection
            loading={loading}
            activeTab={activeTab}
            users={users}
            openAddUser={open}
            addUserOpened={opened}
            closeAddUser={close}
            fetchUsers={fetchUsers}
            openEditUser={openEditUser}
            handleDeleteUser={handleDeleteUser}
            handleViewDetail={handleViewDetail}
          />
        );
      case 'construction-sites':
        return (
          <ConstructionSitesSection
            constructionSites={constructionSites}
            openNewSite={openNewSite}
            openEditSite={openEditSite}
            handleDeleteSite={handleDeleteSite}
          />
        );
      case 'contacts':
        return (
          <ContactsSettingsSection
            loading={loading}
            activeTab={activeTab}
            contacts={contacts}
            fetchContacts={fetchContacts}
            openNewContact={openNewContact}
            openEditContact={openEditContact}
            handleDeleteContact={handleDeleteContact}
          />
        );
      case 'quotes':
        return (
          <QuotesSettingsSection
            loading={loading}
            activeTab={activeTab}
            quotes={quotes}
            fetchQuotes={fetchQuotes}
            openNewQuote={openNewQuote}
            openEditQuote={openEditQuote}
            handleDeleteQuote={handleDeleteQuote}
          />
        );
      case 'feedback':
        return (
          <FeedbackSettingsSection
            loading={loading}
            activeTab={activeTab}
            feedbacks={feedbacks}
            fetchFeedback={fetchFeedback}
          />
        );
      case 'release-notes':
        return (
          <ReleaseNotesAdminPage
          />
        );
      default:
        return null;
    }
  };

  return (
    <Stack gap="lg">
      <Group justify="space-between" align="flex-start">
        <Group gap="sm">
          <IconSettings size={28} color="#228be6" />
          <div>
            <Title order={2}>Ayarlar</Title>
            <Text size="sm" c="dimmed">
              Yönetim paneli modülleri
            </Text>
          </div>
        </Group>

      </Group>

      {error && (
        <Notification icon={<IconX size="1.1rem" />} color="red" onClose={() => setError(null)}>
          {error}
        </Notification>
      )}

      <Group align="flex-start" gap="lg" wrap="nowrap">
        <Paper withBorder radius="md" p="md" w={290} style={{ flexShrink: 0 }}>
          <Stack gap="sm">
            <Text fw={700} size="sm" c="dimmed" tt="uppercase">
              Özellikler
            </Text>

            <Divider />

            <ScrollArea h={520} type="hover">
              <Stack gap={6} pr="xs">
                {sidebarItems.map((item) => {
                  const Icon = item.icon;
                  const isActive = activeTab === item.value;

                  return (
                    <Button
                      key={item.value}
                      variant={isActive ? 'light' : 'subtle'}
                      color={isActive ? item.color : 'gray'}
                      justify="space-between"
                      fullWidth
                      leftSection={<Icon size={18} />}
                      rightSection={isActive ? <IconChevronRight size={16} /> : null}
                      onClick={() => setActiveTab(item.value)}
                      styles={{
                        root: {
                          borderRadius: 12,
                          minHeight: 44,
                        },
                      }}
                    >
                      {item.label}
                    </Button>
                  );
                })}
              </Stack>
            </ScrollArea>

            <Divider />

            <Button
              variant="light"
              color="green"
              leftSection={<IconTerminal2 size={18} />}
              onClick={() => navigate('/logs')}
            >
              Sistem Logları
            </Button>
            <Button
              variant="light"
              color="blue"
              leftSection={<IconApi size={18} />}
              onClick={() => navigate('/endpoints')}
            >
              Endpoint API
            </Button>
          </Stack>
        </Paper>

        <Box style={{ flex: 1, minWidth: 0 }}>
          {renderActiveSection()}
        </Box>
      </Group>

      <Modal
        opened={viewDetailModalOpened}
        onClose={closeViewDetailModal}
        title={<Text fw={700} size="lg">Personel / Kullanıcı Detayı</Text>}
        size="lg"
      >
        {selectedDetailItem && (
          <Stack>
            <Card withBorder shadow="xs" padding="md" radius="md">
              <Group>
                <Avatar size="lg" radius="xl" color="blue">
                  {detailType === 'worker'
                    ? `${selectedDetailItem.first_name?.[0] || ''}${selectedDetailItem.last_name?.[0] || ''}`
                    : selectedDetailItem.username?.[0]?.toUpperCase()}
                </Avatar>

                <div>
                  <Text size="lg" fw={700}>
                    {detailType === 'worker'
                      ? `${selectedDetailItem.first_name || ''} ${selectedDetailItem.last_name || ''}`.trim()
                      : selectedDetailItem.employee
                      ? `${selectedDetailItem.employee.first_name || ''} ${selectedDetailItem.employee.last_name || ''}`.trim()
                      : selectedDetailItem.username}
                  </Text>

                  <Badge color={detailType === 'worker' ? 'orange' : 'blue'}>
                    {detailType === 'worker'
                      ? selectedDetailItem.employee_type || 'SITE'
                      : selectedDetailItem.role || '-'}
                  </Badge>
                </div>
              </Group>

              <Divider my="md" />

              <SimpleGrid cols={2} spacing="xs">
                <Box>
                  <Text size="xs" c="dimmed">Telefon</Text>
                  <Text size="sm">
                    {detailType === 'worker'
                      ? selectedDetailItem.phone || '-'
                      : selectedDetailItem.employee?.phone || '-'}
                  </Text>
                </Box>

                <Box>
                  <Text size="xs" c="dimmed">E-posta</Text>
                  <Text size="sm">
                    {detailType === 'worker'
                      ? selectedDetailItem.email || '-'
                      : selectedDetailItem.employee?.email || '-'}
                  </Text>
                </Box>

                {detailType === 'worker' ? (
                  <>
                    <Box>
                      <Text size="xs" c="dimmed">Pozisyon</Text>
                      <Text size="sm">{selectedDetailItem.position || '-'}</Text>
                    </Box>
                    <Box>
                      <Text size="xs" c="dimmed">Şantiye</Text>
                      <Text size="sm">{selectedDetailItem.site_name || '-'}</Text>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box>
                      <Text size="xs" c="dimmed">Personel Tipi</Text>
                      <Text size="sm">{selectedDetailItem.employee?.employee_type || '-'}</Text>
                    </Box>
                    <Box>
                      <Text size="xs" c="dimmed">Pozisyon</Text>
                      <Text size="sm">{selectedDetailItem.employee?.position || '-'}</Text>
                    </Box>
                  </>
                )}
              </SimpleGrid>
            </Card>

            {detailType === 'worker' && (
              <>
                <Group mt="md">
                  <IconDevices size={20} />
                  <Text fw={600}>Zimmetli Cihazlar</Text>
                </Group>

                {selectedDetailItem.assigned_devices?.length > 0 ? (
                  <Table withTableBorder striped highlightOnHover>
                    <Table.Thead>
                      <Table.Tr>
                        <Table.Th>Cihaz Adı</Table.Th>
                        <Table.Th>Seri No</Table.Th>
                        <Table.Th>Tarih</Table.Th>
                        <Table.Th>Durum</Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {selectedDetailItem.assigned_devices.map((device) => (
                        <Table.Tr key={device.id}>
                          <Table.Td>{device.device_name || '-'}</Table.Td>
                          <Table.Td>
                            <Badge variant="outline" color="gray">
                              {device.device_serial || '-'}
                            </Badge>
                          </Table.Td>
                          <Table.Td>{device.assigned_date || '-'}</Table.Td>
                          <Table.Td>
                            <Badge color="blue" size="sm">
                              {device.status || '-'}
                            </Badge>
                          </Table.Td>
                        </Table.Tr>
                      ))}
                    </Table.Tbody>
                  </Table>
                ) : (
                  <Text c="dimmed" fs="italic" size="sm">
                    Bu personele zimmetli cihaz bulunmamaktadır.
                  </Text>
                )}
              </>
            )}
          </Stack>
        )}
      </Modal>

      <Modal
        opened={siteModalOpened}
        onClose={closeSiteModal}
        title={<Text fw={700}>{siteForm.id ? 'Şantiyeyi Düzenle' : 'Yeni Şantiye Ekle'}</Text>}
        size="lg"
      >
        <Stack gap="sm">
          <TextInput
            label="Şantiye Adı"
            withAsterisk
            value={siteForm.name}
            onChange={(e) => setSiteForm({ ...siteForm, name: e.target.value })}
          />
          <Textarea
            label="Adres / Lokasyon"
            withAsterisk
            value={siteForm.location}
            onChange={(e) => setSiteForm({ ...siteForm, location: e.target.value })}
          />
          <TextInput
            label="Proje Müdürü"
            value={siteForm.project_manager}
            onChange={(e) => setSiteForm({ ...siteForm, project_manager: e.target.value })}
          />
          <SimpleGrid cols={2}>
            <TextInput
              label="İletişim Telefon"
              value={siteForm.contact_phone}
              onChange={(e) => setSiteForm({ ...siteForm, contact_phone: e.target.value })}
            />
            <TextInput
              label="İletişim E-posta"
              value={siteForm.contact_email}
              onChange={(e) => setSiteForm({ ...siteForm, contact_email: e.target.value })}
            />
          </SimpleGrid>
          <SimpleGrid cols={2}>
            <TextInput
              type="date"
              label="Başlangıç Tarihi"
              value={siteForm.start_date}
              onChange={(e) => setSiteForm({ ...siteForm, start_date: e.target.value })}
            />
            <TextInput
              type="date"
              label="Bitiş Tarihi (Tahmini)"
              value={siteForm.expected_end_date}
              onChange={(e) => setSiteForm({ ...siteForm, expected_end_date: e.target.value })}
            />
          </SimpleGrid>
          <Select
            label="Durum"
            data={['aktif', 'tamamlandı', 'askıda']}
            value={siteForm.status}
            onChange={(v) => setSiteForm({ ...siteForm, status: v })}
          />
          <Checkbox
            label="Şantiye Sistemde Aktif mi?"
            checked={siteForm.is_active}
            onChange={(e) => setSiteForm({ ...siteForm, is_active: e.currentTarget.checked })}
            mt="xs"
          />
          <Button mt="md" color="orange" fullWidth loading={isSubmittingSite} onClick={handleSaveSite}>
            Kaydet
          </Button>
        </Stack>
      </Modal>

      <Modal
        opened={editUserModalOpened}
        onClose={closeEditUserModal}
        title={<Text fw={700}>Kullanıcıyı Düzenle</Text>}
      >
        <Stack gap="sm">
          <TextInput
            label="Kullanıcı Adı"
            value={editUserForm.username}
            disabled
            description="Kullanıcı adı değiştirilemez."
          />
          <TextInput label="Personel" value={editUserForm.employee_name} disabled />
          <TextInput label="E-posta" value={editUserForm.employee_email} disabled />
          <TextInput label="Telefon" value={editUserForm.employee_phone} disabled />
          <TextInput label="Pozisyon" value={editUserForm.employee_position} disabled />
          <Select
            label="Kullanıcı Rolü"
            data={availableRoles}
            value={editUserForm.role}
            onChange={(value) => setEditUserForm({ ...editUserForm, role: value })}
            searchable
          />
          <Checkbox
            label="Kullanıcı Aktif mi?"
            checked={editUserForm.is_active}
            onChange={(e) => setEditUserForm({ ...editUserForm, is_active: e.currentTarget.checked })}
          />
          
          <Divider my="xs" />
          
          {/* YENİ EKLENEN ŞİFRE ALANI */}
          <PasswordInput
            label="Yeni Şifre Belirle"
            placeholder="Kullanıcıya yeni şifre atamak isterseniz doldurun"
            description="Şifreyi değiştirmek istemiyorsanız bu alanı boş bırakın."
            value={editUserForm.new_password}
            onChange={(e) => setEditUserForm({ ...editUserForm, new_password: e.target.value })}
          />

          <Divider my="sm" />

          <Group grow>
            <Button
              variant="outline"
              color="orange"
              leftSection={<IconMailForward size={18} />}
              loading={isSubmittingReset}
              onClick={handleSendPasswordReset}
            >
              Şifre Sıfırlama Maili
            </Button>

            <Button color="blue" loading={isSubmittingEditUser} onClick={handleSaveEditUser}>
              Değişiklikleri Kaydet
            </Button>
          </Group>
        </Stack>
      </Modal>

      <Modal
        opened={appModalOpened}
        onClose={closeAppModal}
        title={<Text fw={700}>{appForm.id ? 'Modülü Düzenle' : 'Yeni Modül Ekle'}</Text>}
        size="lg"
      >
        <Stack gap="sm">
          <SimpleGrid cols={2}>
            <TextInput
              label="Başlık"
              withAsterisk
              value={appForm.title}
              onChange={(e) => setAppForm({ ...appForm, title: e.target.value })}
            />
            <TextInput
              label="Rota (Path)"
              withAsterisk
              value={appForm.path}
              onChange={(e) => setAppForm({ ...appForm, path: e.target.value })}
            />
            <Select
              label="İkon"
              data={availableIcons.map((item) => ({ value: item.value, label: item.label }))}
              value={appForm.icon}
              onChange={(value) => setAppForm({ ...appForm, icon: value })}
              leftSection={<SelectedIcon size={18} stroke={1.5} />}
              searchable
            />
            <Select
              label="Renk"
              data={mantineColors}
              value={appForm.color}
              onChange={(value) => setAppForm({ ...appForm, color: value })}
              leftSection={<ThemeIcon color={appForm.color} size="xs" radius="xl" />}
              searchable
            />
          </SimpleGrid>

          <Textarea
            label="Açıklama"
            value={appForm.description}
            onChange={(e) => setAppForm({ ...appForm, description: e.target.value })}
          />

          <SimpleGrid cols={2}>
            <TextInput
              label="İstatistik Anahtarı"
              value={appForm.stat_key}
              onChange={(e) => setAppForm({ ...appForm, stat_key: e.target.value })}
            />
            <TextInput
              label="İstatistik Etiketi"
              value={appForm.stat_label}
              onChange={(e) => setAppForm({ ...appForm, stat_label: e.target.value })}
            />
          </SimpleGrid>

          <MultiSelect
            label="Erişim İzinleri"
            data={[{ value: '*', label: 'Herkes Görüntüleyebilir (*)' }, ...availableRoles]}
            value={appForm.allowed_roles}
            onChange={(selected) => setAppForm({ ...appForm, allowed_roles: selected })}
            searchable
            clearable
          />

          <TextInput
            label="Sıralama"
            type="number"
            value={appForm.order}
            onChange={(e) => setAppForm({ ...appForm, order: e.target.value })}
          />
          <Checkbox
            label="Pek Yakında?"
            checked={appForm.coming_soon}
            onChange={(e) => setAppForm({ ...appForm, coming_soon: e.currentTarget.checked })}
          />
          <Button mt="md" color="violet" fullWidth loading={isSubmittingApp} onClick={handleSaveApp}>
            Kaydet
          </Button>
        </Stack>
      </Modal>

      <Modal
        opened={roleModalOpened}
        onClose={closeRoleModal}
        title={<Text fw={700}>{roleForm.id ? 'Rolü Düzenle' : 'Yeni Rol Ekle'}</Text>}
      >
        <Stack gap="sm">
          <TextInput
            label="Rol Adı"
            withAsterisk
            value={roleForm.name}
            onChange={(e) => setRoleForm({ ...roleForm, name: e.target.value.toLowerCase().trim() })}
            disabled={roleForm.name === 'admin' && roleForm.id}
          />
          <TextInput
            label="Rol Açıklaması"
            value={roleForm.description}
            onChange={(e) => setRoleForm({ ...roleForm, description: e.target.value })}
          />
          <Button mt="md" color="orange" fullWidth loading={isSubmittingRole} onClick={handleSaveRole}>
            Kaydet
          </Button>
        </Stack>
      </Modal>

      <Modal
        opened={contactModalOpened}
        onClose={closeContactModal}
        title={<Text fw={700}>{contactForm.id ? 'Kişiyi Düzenle' : 'Yeni Kişi Ekle'}</Text>}
      >
        <Stack gap="sm">
          <TextInput
            label="Ad Soyad"
            withAsterisk
            value={contactForm.name}
            onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
          />
          <TextInput
            label="Ünvan / Departman"
            value={contactForm.title}
            onChange={(e) => setContactForm({ ...contactForm, title: e.target.value })}
          />
          <TextInput
            label="Dahili"
            withAsterisk
            value={contactForm.ext}
            onChange={(e) => setContactForm({ ...contactForm, ext: e.target.value })}
          />
          <TextInput
            label="Mobil"
            value={contactForm.mobile}
            onChange={(e) => setContactForm({ ...contactForm, mobile: e.target.value })}
          />
          <Button mt="md" color="cyan" fullWidth loading={isSubmittingContact} onClick={handleSaveContact}>
            Kaydet
          </Button>
        </Stack>
      </Modal>

      <Modal
        opened={quoteModalOpened}
        onClose={closeQuoteModal}
        title={<Text fw={700}>{quoteForm.id ? 'Sözü Düzenle' : 'Yeni Söz Ekle'}</Text>}
      >
        <Stack gap="sm">
          <Textarea
            label="Motivasyon Sözü"
            withAsterisk
            minRows={4}
            value={quoteForm.content}
            onChange={(e) => setQuoteForm({ ...quoteForm, content: e.target.value })}
          />
          <Button mt="md" color="blue" fullWidth loading={isSubmittingQuote} onClick={handleSaveQuote}>
            Kaydet
          </Button>
        </Stack>
      </Modal>
    </Stack>
  );
}